import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { jdrrFrameDeliveryStatus } from '../../lib/common';
import styles from './BannerFaq/Faq.module.scss';

function BannerFrameDeliveryStatus({ data }) {
  const [showTrackingDetails, setShowTrackingDetails] = useState(false);
  const trackingDetailsObj = {
    OrderPlaced: {
      text: 'Order Placed',
      subText: 'We have received your order',
      val: data?.acctClearanceDate || '--',
      icon: styles.deliverybox__icon,
    },
    artwork: {
      text: 'Artwork Designed',
      subText: 'Artwork is ready for review. It is sent to client for approval',
      val: data?.artworkSentToClientDate || '--',
      icon: styles.monitor__icon,
    },
    clientApproved: {
      text: 'Client Approved',
      subText: 'No reply within 24 hrs will be considered as approval on design',
      val: data?.clientApprovedDate || '--',
      icon: styles.approvalstatus__icon,
    },
    frame: {
      text: 'Frame Printed & Picked Up',
      subText: 'Printed artwork is picked up by the courier vendor ',
      val: data?.recvdFromPrinterDate || '--',
      icon: styles.package__icon,
    },
    transit: {
      text: 'In Transit',
      subText: 'Received at facility',
      val: data?.transit || '--',
      icon: styles.transit__icon,
    },
    outDelivery: {
      text: 'Out for Delivery',
      subText: 'Received at facility',
      val: data?.dispatchArtworkDate || '--',
      icon: styles.outfordelivery__icon,
    },
    delivered: {
      text: 'Delivered',
      subText: 'Received by owner',
      val: data?.courierDeliveredDate || '--',
      icon: styles.delivered__icon,
    },
  };

  let flag = 0;
  Object.keys(trackingDetailsObj).forEach((key) => {
    if (flag === 1) {
      trackingDetailsObj[key].className = styles.disable;
    }
    if (trackingDetailsObj[key].val !== '--' && flag === 0) {
      trackingDetailsObj[key].className = styles.active;
    }
    if (trackingDetailsObj[key].val === '--' && flag === 0) {
      trackingDetailsObj[key].className = styles.deactive;
      flag = 1;
    }
  });

  return (
    <div className="p-10">
      <ul className={`${styles.ListGroup}`}>
        {data &&
          Object.keys(data).length > 0 &&
          jdrrFrameDeliveryStatus &&
          Object.keys(jdrrFrameDeliveryStatus).map((each, idx) => (
            <li className={`${styles.ListItem}`} key={idx}>
              <label htmlFor={idx} className={`${styles.ListLabel} font13 fw400 color111`}>
                {`${jdrrFrameDeliveryStatus?.[each]}:` || '--'}
              </label>
              <div className={`${styles.ListText} font13 fw500 color111`}>
                :<span className={`capitalize font12 fw500 ml-4 `}>{data?.[each] || '--'}</span>
              </div>
            </li>
          ))}
      </ul>

      <div className="mt-4">
        <button
          id="ButtonNoBackground"
          type="button"
          onClick={() => {
            setShowTrackingDetails(true);
          }}
          className="anchor font13 fw600 color007 pl-4"
        >
          Click Here
        </button>
      </div>

      {showTrackingDetails && (
        <>
          <div className="font12 fw600 color1A1 mt-6 mb-6">JDRR Tracking Details</div>
          <ul className={`${styles.timeline__list}`}>
            {Object.keys(trackingDetailsObj).map((each, i) => (
              <li key={i} className={`${styles.timeline__item} ${trackingDetailsObj?.[each]?.className}`}>
                <div className={`${styles.timeline__item__cirlce} csicon`} />
                <div className={`${styles.timeline__itemcontent}`}>
                  <div className={`${styles.timeline__item__icon} ${trackingDetailsObj?.[each]?.icon} csicon`} />
                  <div className={`${styles.timeline__item__text}`}>
                    <div className={`${styles.timeline__item__heading}`}>
                      <div className={`${styles.heading} font14 fw400 color111`}>
                        {trackingDetailsObj?.[each]?.text || ''}
                      </div>
                      <div className={`${styles.date} font11 fw400 color777`}>
                        {trackingDetailsObj?.[each]?.val || '--'}
                      </div>
                    </div>
                    <div className="font11 fw400 color777">{trackingDetailsObj?.[each]?.subText || ''}</div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}

export default BannerFrameDeliveryStatus;

BannerFrameDeliveryStatus.propTypes = {
  data: PropTypes.object,
};
